// extracted by mini-css-extract-plugin
module.exports = {"select":"oXBnlv","Select-animation-fadeIn":"_2cH9oy","Select-animation-spin":"_2f7gby"};